<template>
	<div>
		<div class="table-box" ref="scroll" >
			<!-- 表头 -->
			<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
				<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<div v-if="rableTitle[0].show_control && rableTitle[0].type==='date_key'" class="table-th-cell"
					:style="{'width':rableTitle[0].width + 'px'}" 
					@click="sortClick(0)">
						投放日期
						<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[0].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[0].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div>
					</div>
					<div v-if="rableTitle[1].show_control && rableTitle[1].type==='op_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[1].width + 'px'}" 
					>
						投手
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[1].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[1].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[2].show_control && rableTitle[2].type==='book_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[2].width + 'px'}" 
					>
						投放作品
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[2].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[2].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[3].show_control && rableTitle[3].type==='book_type'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[3].width + 'px'}" 
					>
						作品类型
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[3].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[3].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[4].show_control && rableTitle[4].type==='platform_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[4].width + 'px'}" 
					>
						媒体平台
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[4].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[4].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[5].show_control && rableTitle[5].type==='media_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[5].width + 'px'}" 
					>
						媒体版位
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[5].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[5].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[6].show_control && rableTitle[6].type==='channel_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[6].width + 'px'}" 
					>
						书城
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[6].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[6].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[7].show_control && rableTitle[7].type==='gzh_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[7].width + 'px'}" 
					>
						公众号/点众渠道号
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[7].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[7].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[8].show_control && rableTitle[8].type==='group_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[8].width + 'px'}" 
					>
						投放小组
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[7].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[7].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
					<div v-if="rableTitle[9].show_control && rableTitle[9].type==='applets_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[9].width + 'px'}" 
					>
						小程序
						<!-- <div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[7].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[7].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div> -->
					</div>
				</div>
				
				<div  v-for="(item,index) in rableTitle" :key="index" >

					<div v-if="item.show_control && (item.type !== 'date_key' && item.type !== 'op_name' && item.type !== 'book_name' && item.type !== 'book_type' && item.type !== 'platform_name' && item.type !== 'media_name' && item.type !== 'channel_name' && item.type !== 'gzh_name' && item.type !== 'group_name' && item.type !== 'applets_name')" class="table-th-cell" 
					:style="{'width':item.width + 'px','justify-content': item.text_right?'flex-end':''}"
					
					@click="sortClick(index)">
						{{item.title}}
						<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div>
					</div>
				</div>
				<!-- 占位，隔出一个空白区域 -->
				<div id="" style="padding:15px;"></div>
			</div>
			
			<!-- 总计 -->
			<div v-if="tableTotalData.length > 0" >
				<div class="table-td" :style="{'width': table_scroll_width + 'px'}">
					<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
						<div  v-for="(item,index) in tableTotalData" :key="index + 100" style="display: flex;align-items: center;">
							<div v-if="item.show_control && (item.keys === 'date_key' || item.keys === 'op_name' || item.keys === 'book_name' || item.keys === 'book_type' || item.keys === 'platform_name' || item.keys === 'media_name' || item.keys === 'channel_name' || item.keys === 'gzh_name' || item.keys === 'group_name' || item.keys === 'applets_name')" class="table-td-cell"
							:style="{'width':item.widths + 'px'}"  :class="{'text-right': item.text_right}">
								{{index === 0?'总计':item.value}}
							</div>
							
						</div>
					</div>
					
					<div v-for="(item,index) in tableTotalData" :key="index" >
						<div v-if="item.show_control && (item.keys !== 'date_key' && item.keys !== 'op_name' && item.keys !== 'book_name' && item.keys !== 'book_type' && item.keys !== 'platform_name' && item.keys !== 'media_name' && item.keys !== 'channel_name' && item.keys !== 'gzh_name' && item.keys !== 'group_name' && item.keys !== 'applets_name')" class="table-td-cell"
						:style="{'width':item.widths + 'px'}"  :class="{'text-right': item.text_right}">
							{{item.value}}
						</div>
					</div>
				</div>
				<!-- <div class="table-td-cell">
					{{tableTotalData.used_money}}
				</div> -->
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<!-- 星期/周维度下的时间跟其他的不一样，要做区分 -->
					<div  v-for="(item_s,index_s) in item" :key="index_s + 1000" style="display: flex;align-items: center;">
						<div v-if="item_s.show_control && item_s.keys === 'date_key'" class="table-td-cell"  :class="{'text-right': item_s.text_right}"
						:style="{'width':item_s.widths + 'px'}">
							{{date_type_control === 'week'?item_s.value.format_date:item_s.value}}
						</div>
						<div v-else-if="item_s.show_control && (item_s.keys === 'op_name' || item_s.keys === 'book_name' || item_s.keys === 'book_type' || item_s.keys === 'platform_name' || item_s.keys === 'media_name' || item_s.keys === 'channel_name' || item_s.keys === 'gzh_name' || item_s.keys === 'group_name' || item_s.keys === 'applets_name')" class="table-td-cell"
						:style="{'width':item_s.widths + 'px'}"  :class="{'text-right': item_s.text_right}">
							{{item_s.value}}
						</div>
						
					</div>
				</div>
				<div v-for="(item_z,index_z) in item" :key="index_z" :class="{'table-td-cell-sticky':index_z === 0}">
					<div v-if="item_z.show_control && (item_z.keys !== 'date_key' && item_z.keys !== 'op_name' && item_z.keys !== 'book_name' && item_z.keys !== 'book_type' && item_z.keys !== 'platform_name' && item_z.keys !== 'media_name' && item_z.keys !== 'channel_name' && item_z.keys !== 'gzh_name' && item_z.keys !== 'group_name' && item_z.keys !== 'applets_name')" class="table-td-cell"  :class="{'text-right': item_z.text_right}" :style="{'width':item_z.widths + 'px'}">
						
						<div v-if="item_z.keys == 'pay_user_num' || item_z.keys == 'sub_num' || item_z.keys == 'today_pay_user_num'">{{item_z.value}}</div>
						<div v-else>{{item_z.value | tableToFixed}}</div>
					</div>
				</div>
				
				
			</div>
			
			
			<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
			
			
			<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
			<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
			
			
		</div>
	</div>
</template>

<script>
export default {
	name: 'TableShow',
	props: ['rableTitle','tableShowData','tableTotalData','table_scroll_width','date_type_control'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index])
			if(index !== this.select_sort_index){
				this.select_sort_index = index
				that.rableTitle.forEach(res=>{
					res.sort_status = 0
				})
				that.rableTitle[index].sort_status = 1
				th_status = 1
			}
			else { // 点击的是同一个表头
				if(that.rableTitle[index].sort_status === 0){
					that.rableTitle[index].sort_status = 1 // 箭头向下
					th_status = 1
				}
				else if(that.rableTitle[index].sort_status === 1){
					that.rableTitle[index].sort_status = 2 // 箭头向上
					th_status = 2
				}
				else if(that.rableTitle[index].sort_status === 2){
					that.rableTitle[index].sort_status = 0
					th_status = 0
				}
			}
			
			let r_type
			if(that.rableTitle[index].type === 'op_name'){ // 投手
				r_type = 'op_id'
			}
			else if(that.rableTitle[index].type === "book_name"){ // 投放作品
				r_type = 'put_book'
			}
			else if(that.rableTitle[index].type === "platform_name"){ // 媒体平台
				r_type = 'type'
			}
			else if(that.rableTitle[index].type === "media_name"){ // 媒体版位
				r_type = 'media_id'
			}
			else if(that.rableTitle[index].type === "channel_name"){ // 书城
				r_type = 'channel_id'
			}
			else if(that.rableTitle[index].type === "gzh_name"){ // 公众号/点众渠道号
				r_type = 'gzh_id'
			}
			else if(that.rableTitle[index].title === "ROI_前7天"){ 
				r_type = 'recent_left_money_roi_before_7'
			}
			else if(that.rableTitle[index].title === "ROI_前6天"){ 
				r_type = 'recent_left_money_roi_before_6'
			}
			else if(that.rableTitle[index].title === "ROI_前5天"){ 
				r_type = 'recent_left_money_roi_before_5'
			}
			else if(that.rableTitle[index].title === "ROI_前4天"){ 
				r_type = 'recent_left_money_roi_before_4'
			}
			else if(that.rableTitle[index].title === "ROI_前3天"){ 
				r_type = 'recent_left_money_roi_before_3'
			}
			else if(that.rableTitle[index].title === "ROI_前2天"){ 
				r_type = 'recent_left_money_roi_before_2'
			}
			else if(that.rableTitle[index].title === "ROI_前1天"){ 
				r_type = 'recent_left_money_roi_before_1'
			}
			else if(that.rableTitle[index].title === "分成金额_前7天"){
				r_type = 'recent_left_money_before_7'
			}
			else if(that.rableTitle[index].title === "分成金额_前6天"){
				r_type = 'recent_left_money_before_6'
			}
			else if(that.rableTitle[index].title === "分成金额_前5天"){
				r_type = 'recent_left_money_before_5'
			}
			else if(that.rableTitle[index].title === "分成金额_前4天"){
				r_type = 'recent_left_money_before_4'
			}
			else if(that.rableTitle[index].title === "分成金额_前3天"){
				r_type = 'recent_left_money_before_3'
			}
			else if(that.rableTitle[index].title === "分成金额_前2天"){
				r_type = 'recent_left_money_before_2'
			}
			else if(that.rableTitle[index].title === "分成金额_前1天"){
				r_type = 'recent_left_money_before_1'
			}
			else {
				r_type = that.rableTitle[index].type
			}
			
			this.$emit('table-th-click', index, th_status, r_type)
		}
	},
	filters: {
		tableToFixed(value){
			// console.log("过滤器",value)
			let v = Number(value)
			return v.toFixed(2)
		}
	}
}
</script>

<style scoped>
	.table-box {
		position: relative;
		width: 100%;
		overflow-x: visible;
	}
	.table-th {
		position:sticky;
		top: 65px;
		z-index:3;
		display: flex;
		align-items: center;
	}
	.table-th-cell {
		display: flex;
		align-items: center;
		padding: 12px 8px;
		cursor: pointer;
		color: #060606;
		flex-shrink: 0;
		background-color: #fbfbfb;
		border-bottom: 1px solid #e8e8e8;
		user-select: none;
		font-size: 13px;
	}
	.table-th-cell:hover {
		background-color: #eee;
	}
	.table-th-cell:hover .table-th-cell-sticky{
		background-color: #eee;
	}
	
	.table-td {
		
		display: flex;
		align-items: center;
		width: 100%;
		border-bottom: 1px solid #e8e8e8;
	}
	.table-td:hover {
		background-color: #eff9ff;
	}
	.table-td:hover .table-td-cell-sticky{
		background-color: #eff9ff;
	}
	.table-td-cell {
		padding: 10px 8px;
		flex-shrink: 0;
		cursor: default;
		word-break: break-all;
		color: rgba(0, 0, 0, 0.65);
		min-height: 40px;
		font-size: 12px;
		/* overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis; */
	}
	.table-td-cell-sticky {
		position: sticky;
		left: 30px;
		z-index: 2;
		background-color: #fff;
	}
	.table-th-cell-sticky {
		position: sticky;
		left: 30px;
		z-index: 2;
		background-color: #fbfbfb;
	}
	
</style>